var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#minus)","key":0},React.createElement("path",{"d":"M22.6564 11.3609V11.3609C22.6563 11.025 22.384 10.7526 22.048 10.7526H11.9647L0.964721 10.7526C0.964712 10.7526 0.964704 10.7526 0.964695 10.7526C0.62871 10.7526 0.356348 11.025 0.356348 11.3609C0.356348 11.6969 0.628724 11.9693 0.964695 11.9693H11.9647H22.0481C22.3841 11.9693 22.6564 11.6969 22.6564 11.3609Z","fill":"#231F20","stroke":"black","strokeWidth":"0.3"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"minus"},React.createElement("rect",{"width":"22","height":"22","fill":"white","transform":"translate(0.506348 0.360962)"})))]);
}

Minus.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
